function About() {
  return (
    <div className="about-page" style={{ maxWidth: "700px", margin: "auto", padding: "2rem" }}>
      <h1>About Me</h1>

      <p>Hey there! Looks like you've stumbled onto my about page — welcome!</p>

      <p>
        I'm a creative explorer on a mission to make things — sometimes too many things. But hey,
        if the ideas are flowing, why not follow where they lead? This site is my home base for all
        my creative projects: animations, graphic novels, webcomics, games, stories, music, and whatever else I can cook up.
      </p>

      <p>
        So... who am I? Well, I was born in 1995 under a harrowing Montana moon, and I’ve been
        chasing stories ever since. I absconded to Mexico in my youth, sought adventure in the
        deserts of Tucson, and lost my hearing battling chupacabras and sunbaked rattlesnakes on the open road.
      </p>

      <p>
        I learned to read from mice and otters in an abbey, swam through rivers in the desert,
        and built my first stories out of tumbleweeds, rust, and daydreams.
      </p>

      <p>
        Whether I’m animating oddball characters, drawing chaotic comics, or writing strange tunes
        on a beat-up guitar, I’m just trying to make things that feel alive — weird, warm, and
        unforgettable.
      </p>

      <p>Thanks for being here. Let’s make some magic.</p>
    </div>
  );
}

export default About;
